module.exports = __webpack_public_path__ + "img/event.6ef119a1.png";